// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Title-module--cds--assistive-text--4pExL";
export var cdsVisuallyHidden = "Title-module--cds--visually-hidden--oVMmq";
export var hideFeedback = "Title-module--hide-feedback--LYUpH";
export var showFeedback = "Title-module--show-feedback--XsPqS";
export var skeleton = "Title-module--skeleton--krZlF";
export var title = "Title-module--title--68bWd";